import React from "react";
import styled from "styled-components";
import { Spacing } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import { Cluster } from "@radarly/models/insights";
import { PICTURE_DETAIL_WIDTH } from "./dimensions";
import Image from "./image";
import ClusterPostTooltip from "./tooltip";

export interface IProps {
  cluster: Cluster;
  locale: Locale;
  timezone: Timezone;
  isFullscreen: boolean;
  detailImageFullscreenSize: number;
}

const Grid = styled.div<{
  isFullscreen: boolean;
  detailImageFullscreenSize: number;
}>`
  margin-top: 6px;
  display: grid;
  grid-template-columns: ${({ isFullscreen, detailImageFullscreenSize }) =>
    isFullscreen
      ? `repeat(auto-fill, minmax(${detailImageFullscreenSize}px, 1fr))`
      : `repeat(auto-fill, minmax(${PICTURE_DETAIL_WIDTH}px, 1fr))`};
  grid-gap: ${Spacing.ExtraSmall};
  overflow: hidden;
  justify-content: space-between;
`;

const ImageClusterDetail = ({
  cluster,
  locale,
  timezone,
  isFullscreen,
  detailImageFullscreenSize,
}: IProps) => {
  return (
    <Grid
      isFullscreen={isFullscreen}
      detailImageFullscreenSize={detailImageFullscreenSize}
    >
      {cluster.hits.map((post) => (
        <Image
          key={post.uid}
          post={post}
          display="grid"
          onClick={() => window.open(post.permalink, "_blank")}
          isFullscreen={isFullscreen}
          detailImageFullscreenSize={detailImageFullscreenSize}
          renderTooltip={() => (
            <ClusterPostTooltip
              post={post}
              locale={locale}
              timezone={timezone}
            />
          )}
        />
      ))}
    </Grid>
  );
};

export default ImageClusterDetail;
